import { render, staticRenderFns } from "./AddReceipt.vue?vue&type=template&id=23d74a56&scoped=true"
import script from "./AddReceipt.vue?vue&type=script&lang=js"
export * from "./AddReceipt.vue?vue&type=script&lang=js"
import style0 from "./AddReceipt.vue?vue&type=style&index=0&id=23d74a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d74a56",
  null
  
)

export default component.exports